<div *ngIf="showBeneficiary && params?.payment=='form'" class="beneficiary-details d-sm-none">
  <div class="flex-div align-items-center">
    <ng-template [ngTemplateOutlet]="profilePic"></ng-template>
    <div class="details">
      <span>Donate to:</span>
      <div class="bene-name">{{fundraiser?.beneficiaryname?.info_1}}</div>
      <span class="heading">{{'Stories.donations.beneficiary' | translatePipe | async}}<i class="material-icons check-circle">check_circle</i></span>
    </div>
    <div class="ketto-assured-logo">
      <app-ketto-assured *ngIf="type==='v1'"></app-ketto-assured>
      <app-ketto-assured-v2 *ngIf="type==='v2'"></app-ketto-assured-v2>
    </div>
  </div>
</div>
<header [ngClass]="{'white-header': params?.payment=='options' && isMobile}">
  <div *ngIf="(params?.payment==='options' || !utilService.isApp()) && !vars.selected_insurance" class="action-icons">
    <button type="button" (click)="back()" mat-icon-button>
      <mat-icon>chevron_left</mat-icon>
      <!-- <span class="back-txt">{{'Stories.donations.back' | translatePipe | async}}</span> -->
    </button>
  </div>
  <div *ngIf="!(params?.payment==='form' && isMobile) && !vars.selected_insurance" class="title">{{getTitle(params.payment, params?.op || params?.method)}}</div>
  <div *ngIf="vars.selected_insurance" class="title partner">Total amount ₹{{vars.selected_insurance.plan_amount}}</div>
  <div *ngIf="params?.type!=='lead' && params.payment!=='options'" class='you-are-donating'>
    <div class="title" *ngIf="isMobile">{{'Stories.donations.donatingIn' | translatePipe | async}}</div>
    <div class="currency-dropdown">
      <app-currency-dropdown *ngIf="supportedCurrencies" [currencies]="supportedCurrencies"
                              [selectedCurrency]="currency" (userSelectionCurrency)="setCurrency($event)">
      </app-currency-dropdown>
    </div>
  </div>
</header>

<ng-template #profilePic>
  <div *ngIf="fundraiser?.media_beneficiary" class="profile-img">
    <img loading="lazy" alt="donor_img" [attr.data-src]="fundraiser?.media_beneficiary?.cdn_path" [alt]="'Profile Pic - '+vars?.beneficiary?.full_name" />
  </div>
  <i *ngIf="!fundraiser?.media_beneficiary" class="icon-user1"></i>
</ng-template>
